var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"locationFilter"},[_c('validation-provider',{attrs:{"name":_vm.name,"mode":"eager","rules":_vm.rules},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var valid = ref.valid;
var errors = ref.errors;
return [_c('b-form-group',{class:errors ? 'is-invalid' : '',attrs:{"label":_vm.label}},[_c('base-multi-select',{attrs:{"list":_vm.cities,"label":"city","value":_vm.value,"state":errors[0] ? false : valid ? true : null,"place-holder":"Select City","error-class":{
          'invalid-selection': errors[0],
        }},on:{"input":_vm.input}}),_c('b-form-invalid-feedback',[_vm._v(_vm._s(errors[0]))])],1)]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }